// import { plugin } from './src/index'
import './src/assets/css/app.css'
import { defineSetupVue3 } from '@histoire/plugin-vue'

export const setupVue3 = defineSetupVue3(({ app, story, variant }) => {
  // app.use(plugin)
})
